import Swal from "sweetalert2";
//sweet alerts for displaying error and info messages to the user and a loader
export default {
  methods: {
    // methods to show and close loader
    show_loader(message, minDisplayTime = 800) {
      const loader = {
        startTime: Date.now(),
        minDisplayTime: minDisplayTime,
        instance: null,
        isClosed: false
      };

      return new Promise((resolve) => {
        loader.instance = Swal.fire({
          text: message,
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            resolve(loader);
          }
        });
      });
    },

    /**
     * Closes the loader, ensuring it's shown for at least the minimum display time
     */
    async close_loader(loader) {
      if (!loader || loader.isClosed) return;

      const elapsed = Date.now() - loader.startTime;
      const remainingTime = loader.minDisplayTime - elapsed;

      if (remainingTime > 0) {
        await new Promise(resolve => setTimeout(resolve, remainingTime));
      }

      if (Swal.isVisible()) {
        Swal.close();
      }
      loader.isClosed = true;
    },
    show_error(message) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        iconHtml: "!",
        title: message,
        showConfirmButton: false,
        timer: 3600,
        timerProgressBar: false,
        showClass: {
          popup: 'swal2-toast-show'
        },
        hideClass: {
          popup: 'swal2-toast-hide'
        },
        customClass: {
          popup: 'error-toast-popup',
          title: 'error-toast-title',
          icon: 'error-toast-icon',
          iconHtml: 'error-toast-icon-mark'
        }
      })
    },
    show_confirm(title, text, confirmCallback, cancelCallback = null) {
      Swal.fire({
        title: title,
        text: text,
        icon: "warning",
        iconHtml: "!",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        customClass: {
          popup: 'danger-confirm-popup',
          title: 'danger-confirm-title',
          htmlContainer: 'danger-confirm-text',
          icon: 'danger-confirm-icon',
          iconHtml: 'danger-confirm-icon-mark',
          actions: 'danger-confirm-actions',
          confirmButton: 'danger-confirm-btn danger-confirm-btn-primary',
          cancelButton: 'danger-confirm-btn danger-confirm-btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          if (confirmCallback && typeof confirmCallback === 'function') {
            confirmCallback();
          }
        } else if (result.isDismissed) {
          if (cancelCallback && typeof cancelCallback === 'function') {
            cancelCallback();
          }
        }
      });
    },
    show_warning(title, text) {
      Swal.fire({
        toast: true,
        position: "top-end",
        title: title,
        text: text,
        icon: "warning",
        iconHtml: "!",
        showConfirmButton: false,
        timer: 3600,
        timerProgressBar: false,
        showClass: {
          popup: 'swal2-toast-show'
        },
        hideClass: {
          popup: 'swal2-toast-hide'
        },
        customClass: {
          popup: 'warning-toast-popup',
          title: 'warning-toast-title',
          htmlContainer: 'warning-toast-text',
          icon: 'warning-toast-icon',
          iconHtml: 'warning-toast-icon-mark'
        }
      });
    },
    show_info(message) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "info",
        iconHtml: "i",
        title: message,
        showConfirmButton: false,
        timer: 3200,
        timerProgressBar: false,
        showClass: {
          popup: 'swal2-toast-show'
        },
        hideClass: {
          popup: 'swal2-toast-hide'
        },
        customClass: {
          popup: 'info-toast-popup',
          title: 'info-toast-title',
          icon: 'info-toast-icon',
          iconHtml: 'info-toast-icon-mark'
        }
      })
    },
    show_success(message) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        iconHtml: "&#10003;",
        title: message,
        showConfirmButton: false,
        timer: 2600,
        timerProgressBar: false,
        showClass: {
          popup: 'swal2-toast-show'
        },
        hideClass: {
          popup: 'swal2-toast-hide'
        },
        customClass: {
          popup: 'success-toast-popup',
          title: 'success-toast-title',
          icon: 'success-toast-icon',
          iconHtml: 'success-toast-icon-check'
        }
      });
    },
    close_modal(modal_id) {
      const modal_element = document.getElementById(modal_id);
      if (modal_element) {
        const modal_instance = window.bootstrap.Modal.getInstance(modal_element) || new window.bootstrap.Modal(modal_element);
        modal_instance.hide();
      }
    }
  },
};
